const $ = require('jquery');

var videoModal = $('.video_modal');
var videoModalIframe = videoModal.find('iframe');
videoModal.on('hidden.bs.modal', function () {
	videoModalIframe.attr("src", videoModalIframe.attr("src"));
});	
